import { render, staticRenderFns } from "./MailIcon.vue?vue&type=template&id=432f495e&scoped=true&"
var script = {}
import style0 from "./MailIcon.vue?vue&type=style&index=0&id=432f495e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432f495e",
  null
  
)

export default component.exports